module.exports = __webpack_public_path__ + "static/media/myZoneTicketingHorizontalWhite.e8e8976a.svg";